import { SATURDAY } from 'lib/flights/charterFlightUtils'
import config from './config'
import { FlightsClassTypes } from './flight'

export const MALDIVES_CHARTER_PRIORITY_SUPPORT_NUMBER_HREF = `tel:${config.MALDIVES_CHARTER_PRIORITY_SUPPORT_NUMBER || ''.replace(/\s+/g, '')}`

export const CHARTER_PAGE_SLUG = 'maldives-direct'

// make as a fallback price for the maldives bundle
export const MALDIVES_BUNDLE_DEFAULT_PRICE_PER_PERSON = 2999

export const MALDIVES_BUNDLE_DEFAULT_NIGHTS = 5

export const MALDIVES_BUNDLE_LABEL = 'Hotel + flight bundle'
export const MALDIVES_CAMPAIGN_NAME = 'Maldives Direct Banner (Maldives Hotel Search)'

export const MALDIVES_MARKETING_BANNER_IMAGE_ID = 'maldives-hotel-flight-bundle-marketing-banner-image'

export const CHARTER_BUNDLE_DURATION_OPTIONS = [
  { value: 5, label: '5 nights + flights' },
  { value: 11, label: '11 nights + flights' },
] as const

export const HOTEL_OFFERS_LIMIT = 12

// Maldives Charter Flight Configuration
export const MALDIVES_CHARTER_CONFIG = {
  DEPARTURE_WEEKDAY: 1, // Monday
  FUTURE_MONTHS_AMOUNT: 7,
  DEPARTURE_AIRPORT: 'MEL',
  ARRIVAL_AIRPORT: 'MLE',
} as const

const melbourneAirport: App.AirportLocation = {
  'id': 3402,
  'cityAirportName': '',
  'cityCode': 'MEL',
  'cityDesc': 'Melbourne',
  'airportCode': 'MEL',
  'airportName': 'Tullamarine',
  'country': 'Australia',
  'isMultiAirport': false,
  'isChildDisplay': true
}

const maleAirport: App.AirportLocation = {
  'id': 2264,
  'cityAirportName': '',
  'cityCode': 'MLE',
  'cityDesc': 'Malé',
  'airportCode': 'MLE',
  'airportName': 'Malé Intl',
  'country': 'Maldives',
  'isMultiAirport': false,
  'isChildDisplay': false,
  'lt': 4.19183016,
  'lg': 73.52909851,
  'isCityAirport': false
}

const sydneyAirport: App.AirportLocation = {
  'id': 3008,
  'cityAirportName': '',
  'cityCode': 'SYD',
  'cityDesc': 'Sydney',
  'airportCode': 'SYD',
  'airportName': 'Sydney',
  'country': 'Australia',
  'isMultiAirport': false,
  'isChildDisplay': false
}

const brisbaneAirport: App.AirportLocation = {
  'id': 3005,
  'cityAirportName': '',
  'cityCode': 'BNE',
  'cityDesc': 'Brisbane',
  'airportCode': 'BNE',
  'airportName': 'Brisbane',
  'country': 'Australia',
  'isMultiAirport': false,
  'isChildDisplay': false
}

const adelaideAirport: App.AirportLocation = {
  'id': 2885,
  'cityAirportName': '',
  'cityCode': 'ADL',
  'cityDesc': 'Adelaide',
  'airportCode': 'ADL',
  'airportName': 'Adelaide',
  'country': 'Australia',
  'isMultiAirport': false,
  'isChildDisplay': false
}

export const leTailImage: App.Image = {
  id: 'LE_Tail',
}

interface CharterFlightDetails {
  /** The airport name as we want to show it in the UI, which doesn't necessarily match what's in the airport data */
  originAirportName: string
  originAirport: App.AirportLocation
  destinationAirport: App.AirportLocation
  feederFlightOrigins: Array<App.AirportLocation>
  fareClassOptions: Array<{
    value: FlightsClassTypes
    label: string
  }>
  operatorName: string
  operatorLogo: App.Image
  departureDays: Array<number>
  returnDays: Array<number>
  validDurations: Array<number>
  supportNumber: {
    humanReadable: string
    href: string
  }
}

export const CHARTER_FLIGHT_DETAILS: { [route in App.CharterBundleRoute]: CharterFlightDetails } = {
  'melbourne-maldives': {
    originAirportName: 'Melbourne Airport',
    originAirport: melbourneAirport,
    destinationAirport: maleAirport,
    feederFlightOrigins: [
      sydneyAirport,
      brisbaneAirport,
      adelaideAirport,
    ],
    fareClassOptions: [
      { value: FlightsClassTypes.ECONOMY, label: 'Economy' },
      { value: FlightsClassTypes.BUSINESS, label: 'Business' },
    ],
    operatorName: 'Maldivian',
    operatorLogo: leTailImage,
    departureDays: [SATURDAY],
    returnDays: [SATURDAY],
    validDurations: [5, 11],
    supportNumber: {
      humanReadable: config.MALDIVES_CHARTER_PRIORITY_SUPPORT_NUMBER,
      href: MALDIVES_CHARTER_PRIORITY_SUPPORT_NUMBER_HREF,
    }
  }
}

export const MALDIVES_CHARTER_BUNDLE_CAMPAIGN_TAG = 'maldives_direct_flight_bundle' as const
